import PricingPage from 'components/Pricing/PricingPage'

export default PricingPage
